import { useMemo } from 'react';
import noop from 'utils/noop';
import { TabState, Tab as TabProps } from './types';
import { StyledButton, StyledTabLabel } from './Tab.styled';

const getTabState = (isSelected: TabProps['isSelected'], isDisabled: TabProps['isDisabled']) => {
  if (isDisabled) {
    return isSelected ? TabState.DisabledSelected : TabState.Disabled;
  } else {
    return isSelected ? TabState.Selected : TabState.Default;
  }
};

/** @deprecated Please use ui/tabsGroup instead for the preferred tab group implementation */
export const Tab = ({
  isSelected = false,
  isDisabled = false,
  label,
  onClick = noop,
  children,
  id,
  squareTheme = false,
  ...otherProps
}: TabProps) => {
  const tabState = useMemo(() => getTabState(isSelected, isDisabled), [isSelected, isDisabled]);
  return (
    <StyledButton
      role="tab"
      aria-selected={isSelected}
      aria-disabled={isDisabled}
      id={id}
      tabState={tabState}
      onClick={onClick}
      data-test={`${id}-${tabState}`}
      squareTheme={squareTheme}
      {...otherProps}
    >
      {label ? <StyledTabLabel>{label}</StyledTabLabel> : children}
    </StyledButton>
  );
};
